// src/services/evaluateApi.ts
import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomBaseQuery } from "./customBaseQuery";

export const evaluateApi = createApi({
  reducerPath: "evaluateApi",
  baseQuery: createCustomBaseQuery(
    "https://evaluate-app-339200407049.us-central1.run.app/"
  ),
  endpoints: (builder) => ({
    evaluateBackend: builder.mutation<any, { app_project_id: string; version_id: string }>(
      {
        query: ({ app_project_id, version_id }) => ({
          url: "evaluate-backend",
          method: "POST",
          body: { app_project_id, version_id },
        }),
      }
    ),

    evaluateFrontend: builder.mutation<any, { app_project_id: string; version_id: string }>(
      {
        query: ({ app_project_id, version_id }) => ({
          url: "evaluate-frontend",
          method: "POST",
          body: { app_project_id, version_id },
        }),
      }
    ),

    // New: fetch nohup logs (GET)
    // Accepts query params: app_project_id, version_id (optional), type=frontend|backend
    fetchNohupLogs: builder.query<any,{ app_project_id: string; version_id?: string; type: "frontend" | "backend" }>({
      query: ({ app_project_id, version_id = "version-1", type }) => {
        // Build query string; adjust param names as your backend expects
        const params = new URLSearchParams({
          app_project_id,
          version_id,
          type,
        });
        return {
          url: `fetch-nohup-logs?${params.toString()}`,
          method: "GET",
        };
      },
      // keepUnusedDataFor small to avoid stale cache if you want fresh on every selection
      keepUnusedDataFor: 10,
    }),
  }),
});

export const {
  useEvaluateBackendMutation,
  useEvaluateFrontendMutation,
  useLazyFetchNohupLogsQuery, // <--- lazy hook for manual trigger
  useFetchNohupLogsQuery, // optional direct hook
} = evaluateApi;
